import { deleteApi, getApi, postApi, putApi } from "../apiCall";

export const alterTableRa = (payload, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/tender/update-times/${id}`;
  return putApi(url, payload);
};

export const bucketFillBefore = () => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/bucketFill/fillAndShortlistForRA`;
  return getApi(url);
};

export const bucketFillAfter = () => {
  let url = `${process.env.REACT_APP_API_URL}/bsra/bucketFill/fillAndShortlistForRAAuctionStage`;
  return getApi(url);
};

export const createTraderMap = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/trader-map`;
  return postApi(url, payload);
};

export const updateTraderMap = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/trader-map`;
  return putApi(url, payload);
};

export const deleteTraderMap = (id) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/trader-map?id=${id}`;
  return deleteApi(url);
};

export const getTraderMap = (companyId, entityType) => {
  let url = `${process.env.REACT_APP_API_URL}/authorization/trader-map/by-company-id?companyId=${companyId}&entityType=${entityType}`;
  return getApi(url);
};
